import React, {
  useEffect,
  createContext,
  useState,
  useLayoutEffect,
  useCallback,
  useMemo,
} from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Home from "./pages/home";
import HomeHealth from "./pages/HomeHealth";
import Home1 from "./pages/home1";
// import Recipes from "./pages/recipes";
import Recipes from "./pages/MyRecipe";
import Projects from "./pages/MyProjects";
import Calendar from "./pages/MyCalendar";

import Banking from "./pages/banking";
import ServiceBooking from "./pages/Services";
import Home2 from "./pages/home2";
import Home3 from "./pages/home3";
import Home4 from "./pages/home4";
import Home5 from "./pages/home5";
import Home6 from "./pages/home6";
import Games from "./pages/games";
import Pricing from "./pages/pricing";
import Pricing2 from "./pages/pricing2";
import Pricing3 from "./pages/pricing3";
import Location from "./pages/location";
import Knowledgebase from "./pages/knowledgebase";
import Faq from "./pages/faq";
import Contact from "./pages/contact";
import News from "./pages/news";
import Image360 from "./pages/image360-Home";
import Affliate from "./pages/affliate";
import Login from "./pages/login";
import Register from "./pages/register";
import { getDataDB, saveDataDB } from "./api";
import moment from "moment";
import { themeStyles } from "./theme"; // Import the theme
import { Background } from "react-parallax";

export const siteName =
  // "luxury";
  "construction";
// "template";
// "fashion";
// "recipes";
// "ageotech";
// "vareprojects";
// "homeHealth";
export const ThemeContext = createContext();
const AppContext = createContext({});
const CURRENT_YEAR = new Date().getFullYear();

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
const HomeComp = siteName === "homeHealth" ? HomeHealth : Home;

const routes = [
  { path: "/", element: <HomeComp /> },
  { path: "/recipes", element: <Recipes /> },
  { path: "/projects", element: <Projects /> },
  { path: "/calendar", element: <Calendar /> },
  { path: "/banking", element: <Banking /> },
  { path: "/services", element: <ServiceBooking /> },
  { path: "/home1", element: <Home1 /> },
  { path: "/home2", element: <Home2 /> },
  { path: "/home3", element: <Home3 /> },
  { path: "/home4", element: <Home4 /> },
  { path: "/home5", element: <Home5 /> },
  { path: "/home6", element: <Home6 /> },
  { path: "/games", element: <Home /> },
  { path: "/service", element: <Home /> },
  { path: "/pricing", element: <Pricing /> },
  { path: "/pricing2", element: <Pricing2 /> },
  { path: "/pricing3", element: <Pricing3 /> },
  { path: "/location", element: <Home /> },
  { path: "/knowledgebase", element: <Knowledgebase /> },
  { path: "/faq", element: <Home /> },
  { path: "/contact", element: <Home /> },
  { path: "/help", element: <Home /> },
  { path: "/news", element: <News /> },
  { path: "/about", element: <Home /> },
  { path: "/affliate", element: <Home /> },
  { path: "/login", element: <Login /> },
  { path: "/register", element: <Register /> },
];

const Navigation = () => (
  <Routes>
    {routes.map(({ path, element }) => (
      <Route key={path} path={path} element={element} />
    ))}
  </Routes>
);

function App() {
  const [appState, setAppState] = useState({
    user: null,
    theme: "light",
  });

  const [myContext, setMyContext] = useState({
    myInfo: {
      handle: "@gamming",
      name: "Admin",
      fullName: "Admin",
    },
  });
  const [theme, setTheme] = useState(themeStyles);

  const updateTheme = (key, value) => {
    setTheme((prevTheme) => {
      const newTheme = { ...prevTheme };
      const keys = key.split(".");
      let obj = newTheme;

      for (let i = 0; i < keys.length - 1; i++) {
        obj = obj[keys[i]];
      }
      obj[keys[keys.length - 1]] = value;
      return newTheme;
    });
  };

  const [myConfig, setMyConfig] = useState({});

  useEffect(() => {
    (async () => {
      return await getDataDB({
        query: {
          siteName: siteName,
        },
        resource: "vare_sites",
      }).then((info) => {
        if (info?.[0]?.config) setMyConfig(info?.[0]?.config);
      });
    })();
  }, []);

  const result = useMemo(() => {
    return {
      about: {
        phone: "+1 (512) 531-9420",
        email: "info@luxdigitallounge.com",
        emailMessage: "or email us at",
        image:
          "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/background/1.webp",
        img: "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/misc/avatar.webp",
        header: "New User Guide:",
        contactUs: "Need help? Call us at",
        subtitle: "Join & Play Now",
        title: ` Select a game system and purchase tokens. You will create a
                  LUX member account during checkout. After processing is
                  complete, you’ll receive an email receipt with your
                  selected game system username and login information.`,
        message: "We will personally guide you and answer all your questions.",
        button: {
          title: "Order Your Game Server Now",
          link: "/",
        },
      },

      collections: {
        title: "Most complete",
        subtitle: "Game Collection",
        show: "Show All",
        games: [
          {
            id: 1,
            title: "Thunder and City",
            price: "$14.99",
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/covers/1.webp",
            discount: "20% OFF",
            button: "Buy Tokens",
            pricemsg: "Starting at",
            priceId: "price_1R6bZl5iE8agXJgNWv4Ynbqn",
          },
          {
            id: 2,
            title: "Mystic Racing Z",
            price: "$14.99",
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/covers/2.webp",
            discount: "20% OFF",
            button: "Buy Tokens",
            pricemsg: "Starting at",
            priceId: "price_1R6bZl5iE8agXJgNWv4Ynbqn",
          },
          {
            id: 3,
            title: "Silent Wrath",
            price: "$14.99",
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/covers/3.webp",
            discount: "20% OFF",
            button: "Buy Tokens",
            pricemsg: "Starting at",
            priceId: "price_1R6bZl5iE8agXJgNWv4Ynbqn",
          },
          {
            id: 4,
            title: "Funk Dungeon",
            price: "$14.99",
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/covers/4.webp",
            discount: "20% OFF",
            button: "Buy Tokens",
            pricemsg: "Starting at",
            priceId: "price_1R6bZl5iE8agXJgNWv4Ynbqn",
          },
          {
            id: 5,
            title: "Galactic Odyssey",
            price: "$14.99",
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/covers/5.webp",
            discount: "20% OFF",
            button: "Buy Tokens",
            pricemsg: "Starting at",
            priceId: "price_1R6bZl5iE8agXJgNWv4Ynbqn",
          },
          {
            id: 6,
            title: "Warfare Legends",
            price: "$14.99",
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/covers/6.webp",
            discount: "20% OFF",
            button: "Buy Tokens",
            pricemsg: "Starting at",
            priceId: "price_1R6bZl5iE8agXJgNWv4Ynbqn",
          },
          {
            id: 7,
            title: "Raceway Revolution",
            price: "$14.99",
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/covers/7.webp",
            discount: "20% OFF",
            button: "Buy Tokens",
            pricemsg: "Starting at",
            priceId: "price_1R6bZl5iE8agXJgNWv4Ynbqn",
          },
          {
            id: 8,
            title: "Starborne Odyssey",
            price: "$14.99",
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/covers/8.webp",
            discount: "20% OFF",
            button: "Buy Tokens",
            pricemsg: "Starting at",
            priceId: "price_1R6bZl5iE8agXJgNWv4Ynbqn",
          },
        ],
      },

      serverLocations: [
        { id: 1, name: "United States", top: "39%", left: "20%" },
        { id: 2, name: "Australia", top: "76%", left: "87%" },
        { id: 3, name: "Indonesia", top: "68%", left: "80%" },
        { id: 4, name: "Canada", top: "23%", left: "18%" },
        { id: 5, name: "Brazil", top: "68%", left: "33%" },
        { id: 6, name: "China", top: "45%", left: "75%" },
        { id: 7, name: "France", top: "36%", left: "48%" },
        { id: 8, name: "Sweden", top: "23%", left: "51%" },
        { id: 9, name: "South Africa", top: "78%", left: "53%" },
      ],

      bannerPointer: {
        subtitle: "Level Up Your Game",
        title: "Your victory begins with ultra performance",
        description: `Welcome to the ultimate gaming experience! Our game hosting 
          service is designed to take your gaming adventures to the next level. 
          With lightning-fast servers, unbeatable reliability, and 24/7 support, 
          we're here to ensure your gaming experience is seamless and stress-free. 
          Join us and let's embark on an epic gaming journey together. 
          Your victory begins here!`,
        buttonText: "Order Your Game Server Now",
        buttonLink: "/",
        stats: [
          {
            iconClass: "fa fa-users",
            value: "15425",
            label: "Happy Gamers",
            extraClass: "b1",
          },
          {
            iconClass: "fa-solid fa-rotate",
            value: "99.99%",
            label: "Uptime",
            extraClass: "b2",
          },
          {
            iconClass: "fa fa-thumbs-up",
            value: "15 Years",
            label: "Experience",
            extraClass: "b3",
          },
        ],
        image: {
          src: "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/misc/server-2.webp",
          alt: "Game Server",
        },
      },

      slides: {
        aiAssist: true,
        menu: false,
        button: "Buy Token",
        label: "Starting at",
        bgSize: "cover", // options: 'cover', 'contain', 'auto'
        bgPosition: "center center", // e.g. 'top center', 'center right'
        bgRepeat: "no-repeat", // e.g. 'repeat', 'repeat-x', 'no-repeat'
        menuas: [
          {
            title: "Event Calendar",
            link: "https://tx50010843.schoolwires.net/Page/2",
          },
          {
            title: "Parent Portal",
            link: "https://portals20.ascendertx.com/ParentPortal/login?distid=014801",
          },
          {
            title: "Required Postings",
            link: "https://tx50010843.schoolwires.net/Page/132",
          },
          {
            title: "Bully/Incident Reporting System",
            link: "https://tx50010843.schoolwires.net/domain/49",
          },
          {
            title: "Staff Directory",
            link: "https://tx50010843.schoolwires.net/domain/22",
          },
          {
            title: "School Closures",
            link: "https://tx50010843.schoolwires.net/domain/65",
          },
          {
            title: "Enroll Now",
            link: "https://hros.websmartsolutions.org/S/RichardMilburnAcademy/StandardAdmissionApplication",
          },
          {
            title: "Request Transcripts",
            link: "https://tx50010843.schoolwires.net/Page/69",
          },
        ],
        slides: [
          {
            id: 1,
            title: "Golden Dragon",
            header: "Tokens Are Available",
            price: "9.99",
            priceId: "price_1R6bZl5iE8agXJgNWv4Ynbqn",
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/slider/1.webp",
            description:
              "Aute esse non magna elit dolore dolore dolor sit est. Ea occaecat ea duis laborum reprehenderit id cillum tempor cupidatat qui nisi proident nostrud dolore",
          },
          {
            id: 2,
            header: "Tokens Are Available",
            title: "Riversweeps",
            price: "12.99",
            priceId: "price_1R6bZl5iE8agXJgNWv4Ynbqn",
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/slider/2.webp",
            description:
              "Aute esse non magna elit dolore dolore dolor sit est. Ea occaecat ea duis laborum reprehenderit id cillum tempor cupidatat qui nisi proident nostrud dolore",
          },
          {
            id: 3,
            title: "Magic City",
            header: "Tokens Are Available",
            price: "14.99",
            priceId: "price_1R6bZl5iE8agXJgNWv4Ynbqn",
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/slider/3.webp",
            description:
              "Aute esse non magna elit dolore dolore dolor sit est. Ea occaecat ea duis laborum reprehenderit id cillum tempor cupidatat qui nisi proident nostrud dolore",
          },
          {
            id: 4,
            title: "T-Rex",
            header: "Tokens Are Available",
            price: "15.99",
            priceId: "price_1R6bZl5iE8agXJgNWv4Ynbqn",
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/slider/4.webp",
            description:
              "Aute esse non magna elit dolore dolore dolor sit est. Ea occaecat ea duis laborum reprehenderit id cillum tempor cupidatat qui nisi proident nostrud dolore",
          },
          {
            id: 5,
            title: "Orion Stars",
            header: "Tokens Are Available",
            price: "16.99",
            priceId: "price_1R6bZl5iE8agXJgNWv4Ynbqn",
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/slider/5.webp",
            description:
              "Aute esse non magna elit dolore dolore dolor sit est. Ea occaecat ea duis laborum reprehenderit id cillum tempor cupidatat qui nisi proident nostrud dolore",
          },
          {
            id: 6,
            title: "Fortune 2 Go",
            header: "Tokens Are Available",
            price: "17.99",
            priceId: "price_1R6bZl5iE8agXJgNWv4Ynbqn",
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/slider/6.webp",
            description:
              "Aute esse non magna elit dolore dolore dolor sit est. Ea occaecat ea duis laborum reprehenderit id cillum tempor cupidatat qui nisi proident nostrud dolore",
          },
          {
            id: 7,
            title: "Play From Home",
            header: "Tokens Are Available",
            price: "18.99",
            priceId: "price_1R6bZl5iE8agXJgNWv4Ynbqn",
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/slider/7.webp",
            description:
              "Aute esse non magna elit dolore dolore dolor sit est. Ea occaecat ea duis laborum reprehenderit id cillum tempor cupidatat qui nisi proident nostrud dolore",
          },
          {
            id: 8,
            title: "UltraPanda",
            header: "Tokens Are Available",
            price: "19.99",
            priceId: "price_1R6bZl5iE8agXJgNWv4Ynbqn",
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/slider/8.webp",
            description:
              "Aute esse non magna elit dolore dolore dolor sit est. Ea occaecat ea duis laborum reprehenderit id cillum tempor cupidatat qui nisi proident nostrud dolore",
          },
          {
            id: 9,
            title: "Juwa",
            header: "Tokens Are Available",
            price: "20.99",
            priceId: "price_1R6bZl5iE8agXJgNWv4Ynbqn",
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/slider/9.webp",
            description:
              "Aute esse non magna elit dolore dolore dolor sit est. Ea occaecat ea duis laborum reprehenderit id cillum tempor cupidatat qui nisi proident nostrud dolore",
          },
        ],
      },

      reviews: {
        title: "Latest From Us",
        subtitle: "News & Promo",
        posts: [
          {
            id: 1,
            name: "Michael S.",
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/people/1.jpg",
            text: "I've been using Playhost for my game server needs, and I couldn't be happier. The server uptime is fantastic, and the customer support team is always quick to assist with any issues.",
          },
          {
            id: 2,
            name: "Robert L.",
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/people/2.jpg",
            text: "Running a game server used to be a hassle, but Playhost makes it easy. The control panel is user-friendly, and I love how they handle server maintenance and updates.",
          },
          {
            id: 3,
            name: "Jake M.",
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/people/3.jpg",
            text: "I've tried several hosting providers in the past, and Playhost is by far the best. Their server performance is top-notch, and I've never experienced lag while playing with friends.",
          },
          {
            id: 4,
            name: "Alex P.",
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/people/4.jpg",
            text: "As a new server owner, I was worried about setup and configuration, but Playhost made it a breeze. They have detailed tutorials and helpful support, which made the process smooth.",
          },
          {
            id: 5,
            name: "Carlos R.",
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/people/5.jpg",
            text: "The flexibility Playhost offers is incredible. I can easily switch between game servers or even host multiple games on the same plan. It's a gamer's dream come true!",
          },
          {
            id: 6,
            name: "Edward B.",
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/people/6.jpg",
            text: "I've been a loyal customer of Playhost for years now. Their dedication to keeping their hardware up-to-date ensures my gaming experience is always optimal.",
          },
          {
            id: 7,
            name: "Daniel H.",
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/people/7.jpg",
            text: "When our community needed a reliable server for our esports tournaments, we turned to Playhost, and they've never let us down. Their servers are perfect for competitive gaming.",
          },
          {
            id: 8,
            name: "Bryan G.",
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/people/8.jpg",
            text: "The DDoS protection from Playhost is a lifesaver. We used to get attacked regularly, but since switching to their servers, we haven't had any downtime.",
          },
        ],
      },
      serviceList: {
        subtitle: "Incredibly features",
        title: "Premium Game Server",
        numberOfColumns: 4, // options: 1, 2, 3, 4
        enableMobileStacking: true,
        cardSpacing: "mb-4", // e.g. 'mb-2', 'mb-4', 'mb-5'
        iconSpacing: "mb-3", // spacing below the icon
        features: [
          {
            icon: "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/icons/1.png",
            title: "Super Quick Setup",
            description:
              "Dolor minim in pariatur in deserunt laboris eu pariatur labore excepteur cupidatat cupidatat duis dolor in.",
          },
          {
            icon: "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/icons/2.png",
            title: "Premium Hardware",
            description:
              "Dolor minim in pariatur in deserunt laboris eu pariatur labore excepteur cupidatat cupidatat duis dolor in.",
          },
          {
            icon: "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/icons/3.png",
            title: "DDos Protection",
            description:
              "Dolor minim in pariatur in deserunt laboris eu pariatur labore excepteur cupidatat cupidatat duis dolor in.",
          },
          {
            icon: "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/icons/4.png",
            title: "Fast Support",
            description:
              "Dolor minim in pariatur in deserunt laboris eu pariatur labore excepteur cupidatat cupidatat duis dolor in.",
          },
        ],
      },
      services: {
        subtitle: "Incredibly features",
        title: "Premium Game Server",
        numberOfColumns: 4, // options: 1, 2, 3, 4
        enableMobileStacking: true,
        cardSpacing: "mb-4", // e.g. 'mb-2', 'mb-4', 'mb-5'
        iconSpacing: "mb-3", // spacing below the icon
        features: [
          {
            icon: "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/icons/1.png",
            title: "Super Quick Setup",
            description:
              "Dolor minim in pariatur in deserunt laboris eu pariatur labore excepteur cupidatat cupidatat duis dolor in.",
          },
          {
            icon: "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/icons/2.png",
            title: "Premium Hardware",
            description:
              "Dolor minim in pariatur in deserunt laboris eu pariatur labore excepteur cupidatat cupidatat duis dolor in.",
          },
          {
            icon: "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/icons/3.png",
            title: "DDos Protection",
            description:
              "Dolor minim in pariatur in deserunt laboris eu pariatur labore excepteur cupidatat cupidatat duis dolor in.",
          },
          {
            icon: "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/icons/4.png",
            title: "Fast Support",
            description:
              "Dolor minim in pariatur in deserunt laboris eu pariatur labore excepteur cupidatat cupidatat duis dolor in.",
          },
        ],
      },

      faqs: {
        title: "Do you have",
        subtitle: "Any questions?",
        faqs: [
          {
            id: "1",
            category: "General",
            question: "What is game hosting?",
            answer:
              "Game hosting refers to the process of renting or setting up servers to run multiplayer online games. These servers allow players to connect and play together in the same game world.",
          },
          {
            id: "2",
            category: "General",
            question: "Why do I need game hosting?",
            answer:
              "Game hosting is essential for multiplayer gaming. It provides a dedicated server where players can join, ensuring a smooth and lag-free gaming experience. It also allows you to customize game settings and mods.",
          },
          {
            id: "3",
            category: "General",
            question: "How do I choose a game hosting provider?",
            answer:
              "Consider factors like server location, performance, scalability, customer support, and price when choosing a game hosting provider. Read reviews and ask for recommendations from fellow gamers.",
          },
          {
            id: "4",
            category: "General",
            question: "What types of games can I host?",
            answer:
              "You can host various types of games, including first-person shooters, role-playing games, survival games, strategy games, and more. The type of game hosting you need depends on the game's requirements.",
          },
          {
            id: "5",
            category: "General",
            question: "What is server latency or ping?",
            answer:
              "Server latency or ping measures the time it takes for data to travel between your computer and the game server. Lower ping values indicate better responsiveness and less lag.",
          },

          {
            id: "6",
            category: "Server Management",
            question: "How do I manage a game server?",
            answer:
              "Game server management varies depending on the hosting provider and game type. Typically, you'll have access to a control panel or command-line interface to configure settings, mods, and player access.",
          },
          {
            id: "7",
            category: "Server Management",
            question: "Can I run mods on my game server?",
            answer:
              "Yes, many game hosting providers support mods. You can install and manage mods to enhance gameplay or customize the game to your liking.",
          },
          {
            id: "8",
            category: "Server Management",
            question: "What is DDoS protection, and do I need it?",
            answer:
              "DDoS (Distributed Denial of Service) protection helps defend your game server from malicious attacks that could disrupt gameplay. It's essential for maintaining server stability, especially for popular games.",
          },
          {
            id: "9",
            category: "Server Management",
            question: "How much does game hosting cost?",
            answer:
              "Game hosting costs vary depending on the provider, server type, and game. Prices can range from a few dollars per month for small servers to hundreds for high-performance dedicated servers.",
          },
          {
            id: "10",
            category: "Server Management",
            question: "Is there 24/7 customer support?",
            answer:
              "Many reputable game hosting providers offer 24/7 customer support to assist with technical issues and server management.",
          },
        ],
      },

      payments: {
        title: "We accept",
        subtitle: "Payment Methods",
        payments: [
          {
            name: "Visa",
            src: "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/payments/visa.webp",
          },
          {
            name: "MasterCard",
            src: "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/payments/mastercard.webp",
          },
          {
            name: "PayPal",
            src: "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/payments/paypal.webp",
          },
          {
            name: "Skrill",
            src: "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/payments/skrill.webp",
          },
          {
            name: "JCB",
            src: "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/payments/jcb.webp",
          },
          {
            name: "American Express",
            src: "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/payments/american-express.webp",
          },
        ],
      },

      blogs: {
        subtitle: "Latest From Us",
        title: "News & Promo",
        blogs: [
          {
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/news/1.webp",
            date: "25.10.2023",
            title: "How to Set Up Your Own Game Server",
            link: "/",
            description:
              "Dolore officia sint incididunt non excepteur ea mollit commodo ut enim reprehenderit cupidatat labore ad laborum consectetur consequat...",
            tags: ["games", "guide"],
            firstTag: "games",
            secondTag: "games",
            firstTagLink: "/",
            secondTagLink: "/",
          },
          {
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/news/2.webp",
            date: "25.10.2023",
            title: "Rise in Demand for Private Game Servers",
            link: "/",
            description:
              "Dolore officia sint incididunt non excepteur ea mollit commodo ut enim reprehenderit cupidatat labore ad laborum consectetur consequat...",
            tags: ["games", "guide"],
            firstTag: "games",
            secondTag: "games",
            firstTag: "games",
            secondTag: "games",
            firstTagLink: "/",
            secondTagLink: "/",
          },
          {
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/news/3.webp",
            date: "25.10.2023",
            title: "Top Hosting Providers for Game Servers",
            link: "/",
            description:
              "Dolore officia sint incididunt non excepteur ea mollit commodo ut enim reprehenderit cupidatat labore ad laborum consectetur consequat...",
            tags: ["games", "guide"],
            firstTag: "games",
            secondTag: "games",
            firstTag: "games",
            secondTag: "games",
            firstTagLink: "/",
            secondTagLink: "/",
          },
        ],
      },

      marquees: {
        locations: [
          {
            name: "London",
            flag: "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/flags/united-kingdom.png",
          },
          {
            name: "Paris",
            flag: "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/flags/france.png",
          },
          {
            name: "Frankfurt",
            flag: "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/flags/germany.png",
          },
          {
            name: "Amsterdam",
            flag: "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/flags/netherlands.png",
          },
          {
            name: "Stockholm",
            flag: "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/flags/sweden.png",
          },
          {
            name: "Helsinki",
            flag: "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/flags/finland.png",
          },
          {
            name: "Los Angeles",
            flag: "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/flags/usa.png",
          },
          {
            name: "Quebec",
            flag: "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/flags/canada.png",
          },
          {
            name: "Singapore",
            flag: "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/flags/sg.png",
          },
          {
            name: "Sydney",
            flag: "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/flags/australia.png",
          },
          {
            name: "Sao Paulo",
            flag: "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/flags/brazil.png",
          },
          {
            name: "Bangkok",
            flag: "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/flags/thailand.png",
          },
          {
            name: "Jakarta",
            flag: "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/flags/indonesia.png",
          },
        ],
      },
      // pricings: {
      //   options: [
      //     { name: "GB", title: "London, England" },
      //     { name: "FR", title: "Paris, France" },
      //     { name: "DE", title: "Frankfurt, Germany" },
      //     { name: "NL", title: "Amsterdam, Netherlands" },
      //     { name: "SE", title: "Stockholm, Sweden" },
      //     { name: "FI", title: "Helsinki, Finland" },
      //     { name: "US", title: "Los Angeles, USA" },
      //     { name: "QC", title: "Quebec, Canada" },
      //     { name: "AU", title: "Sydney, Australia" },
      //     { name: "BR", title: "Sao Paulo, Brazil" },
      //     { name: "TH", title: "Bangkok, Thailand" },
      //     { name: "ID", title: "Jakarta, Indonesia" },
      //   ],
      //   plans: [
      //     { slots: "4 Slots", monthly: 3.59, yearly: 2.59, original: 9.99, priceId: '' },
      //     { slots: "10 Slots", monthly: 5.59, yearly: 3.59, original: 15.99 },
      //     { slots: "20 Slots", monthly: 8.59, yearly: 5.59, original: 24.99, bestSeller: true },
      //     { slots: "Custom", monthly: 15.59, yearly: 10.59, original: 36.99 },
      //   ],
      //   features: [
      //     "Super Quick Setup",
      //     "Premium Hardware",
      //     "DDoS Protection",
      //     "24/7 Customer Support"
      //   ],
      //   labels: {
      //     normalPrice: "Normally",
      //     serverLocation: "Server Location",
      //     topFeatures: "Top Features"
      //   },
      //   notes: {
      //     renewText: "Auto renews at regular rate"
      //   }
      // },

      pricings: {
        title: "Pricing Plans",
        subtitle: "Choose a Plan for You",
        // leftPlan: 'Monthly Plan',
        // rightPlan: 'Yearly Plan',
        options: [
          { name: "GB", title: "London, England" },
          { name: "FR", title: "Paris, France" },
          { name: "DE", title: "Frankfurt, Germany" },
          { name: "NL", title: "Amsterdam, Netherlands" },
          { name: "SE", title: "Stockholm, Sweden" },
          { name: "FI", title: "Helsinki, Finland" },
          { name: "US", title: "Los Angeles, USA" },
          { name: "QC", title: "Quebec, Canada" },
          { name: "AU", title: "Sydney, Australia" },
          { name: "BR", title: "Sao Paulo, Brazil" },
          { name: "TH", title: "Bangkok, Thailand" },
          { name: "ID", title: "Jakarta, Indonesia" },
        ],
        plans: [
          {
            slots: "4 Slots",
            monthly: 3.59,
            yearly: 2.59,
            original: 9.99,
            button: "Get Monthly Plan",
            button2: "Get Yearly Plan",
            features: [
              { name: "Super Quick Setup" },
              { name: "Premium Hardware" },
              { name: "DDoS Protection" },
              { name: "24/7 Customer Support" },
            ],
            priceId: "price_1R6bZl5iE8agXJgNWv4Ynbqn",
          },
          {
            slots: "10 Slots",
            monthly: 5.59,
            yearly: 3.59,
            original: 15.99,
            button: "Get Monthly Plan",
            button2: "Get Yearly Plan",
            features: [
              { name: "Super Quick Setup" },
              { name: "Premium Hardware" },
              { name: "DDoS Protection" },
              { name: "24/7 Customer Support" },
            ],
            priceId: "price_1R6bZl5iE8agXJgNWv4Ynbqn",
          },
          {
            slots: "20 Slots",
            monthly: 8.59,
            yearly: 5.59,
            original: 24.99,
            bestSeller: true,
            button: "Get Monthly Plan",
            button2: "Get Yearly Plan",
            features: [
              { name: "Super Quick Setup" },
              { name: "Premium Hardware" },
              { name: "DDoS Protection" },
              { name: "24/7 Customer Support" },
            ],
            priceId: "price_1R6bZl5iE8agXJgNWv4Ynbqn",
          },
          {
            slots: "Custom",
            monthly: 15.59,
            yearly: 10.59,
            original: 36.99,
            button: "Get Monthly Plan",
            button2: "Get Yearly Plan",
            features: [
              { name: "Super Quick Setup" },
              { name: "Premium Hardware" },
              { name: "DDoS Protection" },
              { name: "24/7 Customer Support" },
            ],
            priceId: "price_1R6bZl5iE8agXJgNWv4Ynbqn",
          },
        ],
        labels: {
          normalPrice: "Normally",
          serverLocation: "Server Location",
          topFeatures: "Top Features",
        },
        notes: {
          renewText: "Auto renews at regular rate",
        },
      },

      footers: {
        header1: "Game Server",
        header2: "Pages",
        header3: "Newsletter",
        header4: "Follow Us on",
        title: ` Lorem ipsum culpa tempor tempor eu laboris adipisicing sunt excepteur enim laborum
                      officia eiusmod laborum sint do aliqua incididunt est aute deserunt in elit non sed ut
                      velit ullamco aliquip. Nulla cupidatat elit amet sed labore ut et consequat nostrud
                      laboris aliqua ex est fugiat quis aliqua duis quis esse dolor laboris non duis sunt.`,
        logo: "./img/logo.png",
        services: [
          { name: "Thunder and City" },
          { name: "Mystic Racing Z" },
          { name: "Silent Wrath" },
          { name: "Funk Dungeon" },
          { name: "Galactic Oddsey" },
          { name: "Warfare Legend" },
        ],
        pages: [
          { name: "Warfare Legend" },
          { name: "Game Server" },
          { name: "Knowledgebase" },
          { name: "About Us" },
          { name: "Affiliates" },
          { name: "Locations" },
          { name: "News" },
        ],
        links: [
          { icon: "fa-facebook-f", path: "/" },
          { icon: "fa-twitter", path: "/" },
          { icon: "fa-discord", path: "/" },
          { icon: "fa-tiktok", path: "/" },
          { icon: "fa-youtube", path: "/" },
        ],
        emailMessage: "Your email is safe with us. We don&apos;t spam.",
        copyright: `Copyright ${CURRENT_YEAR} - Playhost by Designesia`,
        terms: `Terms &amp; Conditions`,
        policy: "Privacy Policy",
      },

      banners: {
        BG_IMAGE:
          "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/background/2.webp",
        IMAGE:
          "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/misc/man-with-phone.webp",
        SUBTITLE: "PLAY ALL YOU WANT",
        HEADING: "Sign up for occasional newsletters and promotions",
        DESCRIPTION:
          "Enim sit laborum enim ut in excepteur aliqua consequat est ut aliquip nostrud sunt deserunt consequat fugiat adipisicing minim aliquip do adipisicing cupidatat esse ut irure incididunt ullamco dolor laboris anim ea do ut anim.",
      },

      blogsnotitle: {
        blogs: [
          {
            id: 1,
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/news/1.webp",
            date: "25.10.2023",
            title: "How to Set Up Your Own Game Server",
            excerpt:
              "Dolore officia sint incididunt non excepteur ea mollit commodo ut enim reprehenderit cupidatat labore ad laborum consectetur consequat...",
            firstTag: "games",
            secondTag: "games",
            firstTagLink: "/",
            secondTagLink: "/",
          },
          {
            id: 2,
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/news/2.webp",
            date: "25.10.2023",
            title: "Rise in Demand for Private Game Servers",
            excerpt:
              "Dolore officia sint incididunt non excepteur ea mollit commodo ut enim reprehenderit cupidatat labore ad laborum consectetur consequat...",
            firstTag: "games",
            secondTag: "games",
            firstTagLink: "/",
            secondTagLink: "/",
          },
          {
            id: 3,
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/news/3.webp",
            date: "25.10.2023",
            title: "Top Hosting Providers for Game Servers",
            excerpt:
              "Dolore officia sint incididunt non excepteur ea mollit commodo ut enim reprehenderit cupidatat labore ad laborum consectetur consequat...",
            firstTag: "games",
            secondTag: "games",
            firstTagLink: "/",
            secondTagLink: "/",
          },
          {
            id: 4,
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/news/4.webp",
            date: "25.10.2023",
            title: "E-Sports and Competitive Gaming",
            excerpt:
              "Dolore officia sint incididunt non excepteur ea mollit commodo ut enim reprehenderit cupidatat labore ad laborum consectetur consequat...",
            firstTag: "games",
            secondTag: "games",
            firstTagLink: "/",
            secondTagLink: "/",
          },
          {
            id: 5,
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/news/5.webp",
            date: "25.10.2023",
            title: "How to Protect Your Online World",
            excerpt:
              "Dolore officia sint incididunt non excepteur ea mollit commodo ut enim reprehenderit cupidatat labore ad laborum consectetur consequat...",
            firstTag: "games",
            secondTag: "games",
            firstTagLink: "/",
            secondTagLink: "/",
          },
          {
            id: 6,
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/news/6.webp",
            date: "25.10.2023",
            title: "5 Ways to Maintain a Good Posture",
            excerpt:
              "Dolore officia sint incididunt non excepteur ea mollit commodo ut enim reprehenderit cupidatat labore ad laborum consectetur consequat...",
            firstTag: "games",
            secondTag: "games",
            firstTagLink: "/",
            secondTagLink: "/",
          },
        ],
      },

      banners2: {
        title: "Server Locations",
        image: "./img/misc/server.webp",
        subtitle: " servers available worldwide for your game.",
        description: `Our collection of game server hosting options encompasses the most in-demand platforms of today. Within our
                  offerings, you'll discover an extensive array of specialized tools and features tailored to each game, all of
                  which we diligently keep up to date in sync with game and mod updates.`,
        view: "View all available servers",
        count: "25",
        data: [
          { title: "London, England", link: "/servers/london" },
          { title: "Paris, France", link: "/servers/paris" },
          { title: "Frankfurt, Germany", link: "/servers/frankfurt" },
          { title: "Amsterdam, Netherlands", link: "/servers/amsterdam" },
          { title: "Stockholm, Sweden", link: "/servers/stockholm" },
          { title: "Helsinki, Finland", link: "/servers/helsinki" },
          { title: "Los Angeles, USA", link: "/servers/los-angeles" },
        ],
      },

      pricelists: {
        PRICING_PLANS_TITLE: "Pricing Plans",
        CHOOSE_PLAN_TEXT: "Choose plan for you",
        MONTHLY_PLAN_TEXT: "Monthly Plan",
        YEARLY_PLAN_TEXT: "Yearly Plan",
        leftPlan: "Monthly Plan",
        rightPlan: "Yearly Plan",
        plans: [
          {
            title: "Warrior",
            slots: 40,
            itemA: "",
            itemB: "",
            memory: "4GB",
            priceMonthly: 14.99,
            priceYearly: 9.99,
            priceId: "ssss",
          },
          {
            title: "General",
            slots: 60,
            itemA: "",
            itemB: "",
            memory: "8GB",
            priceMonthly: 19.99,
            priceYearly: 14.99,
            bestSeller: true,
            priceId: "233333",
          },
          {
            title: "Commander",
            slots: 125,
            itemA: "",
            itemB: "",
            memory: "16GB",
            priceMonthly: 29.99,
            priceYearly: 24.99,
            priceId: "34444",
          },
        ],
      },

      videoanimates: {
        videoId: "QB2DfxkaBeU",
        subtitle: "Servers Are Available",
        title: "Minecraft Server Hosting",
        description:
          "Aute velit non excepteur in eiusmod proident aute qui ullamco incididunt aliqua aliqua velit cillum deserunt dolore consectetur excepteur magna dolor enim voluptate dolore irure nulla culpa sint nulla do.",
        buttonText: "Compare Our Plans",
        rating: 4.85,
        reviews: 14086,
      },

      locations: {
        title: "Server Locations",
        subtitle: "25 servers worldwide.",
        locations: [
          { name: "United States", top: "39%", left: "20%" },
          { name: "Australia", top: "76%", left: "87%" },
          { name: "Indonesia", top: "68%", left: "80%" },
          { name: "Canada", top: "23%", left: "18%" },
          { name: "Brazil", top: "68%", left: "33%" },
          { name: "China", top: "45%", left: "75%" },
          { name: "France", top: "36%", left: "48%" },
          { name: "Sweden", top: "23%", left: "51%" },
          { name: "South Africa", top: "78%", left: "53%" },
        ],
        marquee: [
          { name: "London" },
          { name: "Paris" },
          { name: "Frankfurt" },
          { name: "Amsterdam" },
          { name: "Stockholm" },
          { name: "Helsinki" },
          { name: "Los Angeles" },
          { name: "Quebec" },
          { name: "Singapore" },
          { name: "Sydney" },
          { name: "Sao Paulo" },
          { name: "Bangkok" },
          { name: "Jakarta" },
        ],
        mapImage:
          "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/misc/world-map.webp",
      },
      populars: {
        title: "Popular",
        subtitle: "Game Servers",
        games: [
          {
            name: "Thunder and City",
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/covers-square/1.webp",
          },
          {
            name: "Mystic Racing",
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/covers-square/2.webp",
          },
          {
            name: "Silent Wrath",
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/covers-square/3.webp",
          },
          {
            name: "Funk Dungeon",
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/covers-square/4.webp",
          },
          {
            name: "Galactic Odyssey",
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/covers-square/5.webp",
          },
          {
            name: "Warfare Legends",
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/covers-square/6.webp",
          },
          {
            name: "Raceway Revolutions",
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/covers-square/7.webp",
          },
          {
            name: "Starborne Odyssey",
            image:
              "https://varefiles.s3.us-east-2.amazonaws.com/gamming/img/covers-square/8.webp",
          },
        ],
      },

      menubs: {
        menubs: [
          { title: "London, England", link: "/servers/london" },
          { title: "Paris, France", link: "/servers/paris" },
          { title: "Frankfurt, Germany", link: "/servers/frankfurt" },
          { title: "Amsterdam, Netherlands", link: "/servers/amsterdam" },
          { title: "Stockholm, Sweden", link: "/servers/stockholm" },
          { title: "Helsinki, Finland", link: "/servers/helsinki" },
          { title: "Los Angeles, USA", link: "/servers/los-angeles" },
        ],
      },

      menuas: {
        menuas: [
          {
            title: "Event Calendar",
            link: "https://tx50010843.schoolwires.net/Page/2",
          },
          {
            title: "Parent Portal",
            link: "https://portals20.ascendertx.com/ParentPortal/login?distid=014801",
          },
          {
            title: "Required Postings",
            link: "https://tx50010843.schoolwires.net/Page/132",
          },
          {
            title: "Bully/Incident Reporting System",
            link: "https://tx50010843.schoolwires.net/domain/49",
          },
          {
            title: "Staff Directory",
            link: "https://tx50010843.schoolwires.net/domain/22",
          },
          {
            title: "School Closures",
            link: "https://tx50010843.schoolwires.net/domain/65",
          },
          {
            title: "Enroll Now",
            link: "https://hros.websmartsolutions.org/S/RichardMilburnAcademy/StandardAdmissionApplication",
          },
          {
            title: "Request Transcripts",
            link: "https://tx50010843.schoolwires.net/Page/69",
          },
        ],
      },

      myorder: [
        "navbars",
        "menubs",
        // "menuas",
        // "menucs",
        "swiper",
        "serviceList",
        "aboutUs",
        "reviews",
        "collections",
        // "collection",
        "help",
        "payment",
        "homestatic",
        "marquees",
        "blogs",
        "pricings",
        "pricelists",
        "videoanimates",
        "locations",
        "populars",
        "banners",
        "banners2",
        "footers",
      ],

      navbars: {
        nav_links: [
          { to: "/", label: "Home" },
          { to: "#games", label: "Games" },
          { to: "#contact", label: "Contacts" },
          { to: "#location", label: "Locations" },
        ],
        // logo_images: {
        //   desktop: "./img/logo.png",
        //   mobile: "./img/logo-mobile.png",
        //   height: "100"
        // },
        logo_desktop: {
          image: "./img/logo.png",
          height: "100",
        },
        logo_mobile: {
          image: "./img/logo-mobile.png",
          height: "100",
        },
      },
    };
  }, []);

  useEffect(() => {
    (async () => {
      const info = myConfig && Object.keys(myConfig) ? myConfig : result;
      //  await addMissingProps({
      //   source: result,
      //   target: myConfig
      // })

      console.log("aksasknaskn", result);

      setAppState({
        myorder: [
          "navbars",

          // "menucs",
          "swiper",
          "menubs",
          "menuas",
          "serviceList",
          "aboutUs",
          "reviews",
          "collections",
          "help",
          "payment",
          "homestatic",
          "marquees",
          "blogs",
          "pricings",
          "pricelists",
          "videoanimates",
          "locations",
          "populars",
          "banners",
          "banners2",
          "menucs",
          "footers",
        ],
        ...info,
        // pricings: result?.pricings,
        editItemMain: {},
        backupConfig: info,
        defaultConfig: result,
        section: "",
      });
    })();
  }, [result, myConfig]);

  return (
    <ThemeContext.Provider value={{ theme, updateTheme }}>
      <AppContext.Provider
        value={{
          appState,
          setAppState,
          myContext,
          setMyContext,
        }}
      >
        <HelmetProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Navigation />
          </BrowserRouter>
        </HelmetProvider>
      </AppContext.Provider>
    </ThemeContext.Provider>
  );
}

export { AppContext };
export default App;

const addMissingProps = async ({ source, target }) => {
  // Helper function to determine if a value is an object
  const isObject = (obj) => obj && typeof obj === "object";

  // If source is not an object or is null, return the target as is
  if (!isObject(source)) return target;
  // If target is not an object or is null, return a shallow copy of the source
  if (!isObject(target)) return { ...source };

  // Initialize the result as a shallow copy of the target
  const result = Array.isArray(target) ? [...target] : { ...target };

  // Iterate over each key in the source object
  for (const key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      // If the key doesn't exist in the result, add it from the source
      if (!(key in result)) {
        result[key] = source[key];
      } else if (isObject(source[key]) && isObject(result[key])) {
        // If both source and result have the same key and the values are objects,
        // recursively merge them
        result[key] = await addMissingProps({
          source: source[key],
          target: result[key],
        });
      }
      // If the key exists in both but the values are not both objects, retain the target's value
    }
  }

  return result;
};
